import { useContext, useEffect } from "react";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";
import {
  Board,
  ProductionStatus,
  Shipment,
} from "../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";
import FlashPCBSelect, { OptionType } from "../../common/FlashPCBSelect";
import { formatShipmentLine } from "../../../utils/valueFormatting";
import useShipmentsFromContext from "../../../utils/hooks/commonly-stored/uploaded-board/shipments";

export default function SelectShipment() {
  const { shipmentId, setShipmentId } = useContext(
    BoardIdContext,
  ) as BoardShipmentIds;
  const board = useBoardFromContext().board as Board;
  const shipments = useShipmentsFromContext(board.id) as Shipment[];

  useEffect(() => {
    if (shipmentId === null && setShipmentId !== undefined) {
      const nextShipment = shipments.find((shipment) => {
        return shipment.production_status == ProductionStatus.MANUFACTURING;
      });
      if (nextShipment !== undefined) {
        setShipmentId(nextShipment.id);
      } else {
        setShipmentId((shipments.at(-1) as Shipment).id);
      }
    }
  }, [shipments, setShipmentId, shipmentId]);

  if (setShipmentId === undefined) {
    return;
  }

  const shipment = shipments.find((shipment) => {
    return shipment.id == shipmentId;
  });

  const handleShipmentChange = (newValue: OptionType | null) => {
    if (newValue !== null) {
      setShipmentId(newValue.value);
    }
  };

  return (
    <FlashPCBSelect
      label={"Select shipment"}
      options={shipments.map((shipment) => {
        return {
          label: formatShipmentLine(shipment),
          value: shipment.id,
        };
      })}
      value={
        shipment && {
          label: formatShipmentLine(shipment),
          value: shipment.id,
        }
      }
      onChange={handleShipmentChange}
    />
  );
}
